import { render, staticRenderFns } from "./QuotesByAges.vue?vue&type=template&id=71f017ef&scoped=true&"
import script from "./QuotesByAges.vue?vue&type=script&lang=js&"
export * from "./QuotesByAges.vue?vue&type=script&lang=js&"
import style0 from "./QuotesByAges.vue?vue&type=style&index=0&id=71f017ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f017ef",
  null
  
)

export default component.exports